import {ConversionType, TaskStatusType} from "../../types/taskFlow.types";
import {useTaskFlow} from "../../context/TaskFlowContext";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import {Button} from "@mui/material";
import { useTranslation } from 'react-i18next'

interface TaskToolProps {
    status: TaskStatusType,
    text: string,
    taskId?: number,
    triggerEvent?: () => void;
}

export default function TaskTool(props: TaskToolProps) {
    const {status, taskId, triggerEvent, text} = props;
    const {updateStatus, conversionValue, changeTaskProcess} = useTaskFlow()
    const changeStatus = () => {
        taskId && changeTaskProcess(taskId, {status: TaskStatusType.COMPLETED})
    }

    const { t } = useTranslation()

    return  <>
        {
            status === TaskStatusType.COMPLETED ?
                <span style={{color: 'var(--c-accent)', fontSize: 12, display: 'flex', whiteSpace: "nowrap", marginLeft: 10}}>{t('confirmed')} <CheckOutlinedIcon style={{fontSize: 16}} /></span>
                : conversionValue === ConversionType.CONVERSING && <Button onClick={()=>{
                    changeStatus()
                    updateStatus(taskId, TaskStatusType.COMPLETED)
                    setTimeout(()=>{
                        triggerEvent && triggerEvent()
                    }, 500)
                }} variant="contained" size='small' style={{
                marginLeft: 10,
                height: '25px',
                display: 'none'
            }}>{text}</Button>
        }
    </>
}